import { ColumnConfig } from 'src/app/components/shared/table/components/table/types';
import { ActiveCarryOverLoads } from 'src/app/core/models/position-operations/carry-over-loads.model';

export const CONST = {
  HEADER: $localize`ULD Count`,
  SELECT_DATE: $localize`Select Date`,
  CLOSE_DATE: $localize`Close Date`,
  CLOSE_TIME: $localize`Close Time`,
  PERCENT_FULL: $localize`Percent Full`,
  SUBMIT: $localize`Submit`,
  SEARCH: $localize`Search`,
  LOAD_KEY_UPDATE: $localize`Load Key Update`,
};

export enum ColumnIds {
  ULD_NUMBER = 'uldNumber',
  ULD_TYPE = 'uldType',
  LOAD_KEY = 'loadKey',
  LOAD_CHART = 'loadChart',
  MOVEMENT = 'movement',
  SEAL_NUMBER = 'sealNumber',
  ULD_PKG_COUNT = 'uldPkgCount',
  LOAD_CREATE_DATE = 'loadCreateDate',
  ORIG_SORT = 'origSort',
}

export const ColumnText = {
  ULD_NUMBER: $localize`ULD NUMBER`,
  ULD_TYPE: $localize`ULD Type`,
  LOAD_KEY: $localize`Load Key`,
  LOAD_CHART: $localize`Load Chart`,
  MOVEMENT: $localize`Movement`,
  SEAL_NUMBER: $localize`Seal Number`,
  ULD_PKG_COUNT: $localize`ULD/Loose Count`,
  LOAD_CREATE_DATE: $localize`Load Create Date`,
  ORIGIN_SORT: $localize`Origin Sort`,
};

export const COLUMN_CONFIG: ColumnConfig[] = [
  {
    key: ColumnIds.ULD_NUMBER,
    title: ColumnText.ULD_NUMBER,
    isUpperCase: true,
    hasCustomHeader: true,
    hasRender: true,
  },
  {
    key: ColumnIds.ULD_TYPE,
    title: ColumnText.ULD_TYPE,
    isUpperCase: true,
  },
  {
    key: ColumnIds.LOAD_KEY,
    title: ColumnText.LOAD_KEY,
    isUpperCase: true,
  },
  {
    key: ColumnIds.LOAD_CHART,
    title: ColumnText.LOAD_CHART,
    isUpperCase: true,
  },
  {
    key: ColumnIds.MOVEMENT,
    title: ColumnText.MOVEMENT,
    isUpperCase: true,
  },
  {
    key: ColumnIds.SEAL_NUMBER,
    title: ColumnText.SEAL_NUMBER,
    isUpperCase: true,
  },
  {
    key: ColumnIds.ULD_PKG_COUNT,
    title: ColumnText.ULD_PKG_COUNT,
    isUpperCase: true,
    hasRender: true,
  },
  {
    key: ColumnIds.LOAD_CREATE_DATE,
    title: ColumnText.LOAD_CREATE_DATE,
    isUpperCase: true,
  },
  {
    key: ColumnIds.ORIG_SORT,
    title: ColumnText.ORIGIN_SORT,
    isUpperCase: true,
    hasRender: true,
  },
];

export type UldCountItem = {
  uldNumber: string;
  uldType: string;
  loadKey: string;
  uldCount: string;
  pkgCount: string;
  loadCreateDate: string;
  origSort: string;
};
export const MOCK_TABLE_CONSTS: ActiveCarryOverLoads[] = [
  {
    id: 123,
    uldNumber: 'UPST720230',
    uldType: 'T',
    loadKey: 'GB',
    uldCount: '0',
    pkgCount: '0',
    loadCreateDate: 'August 8, 2020',
    origSort: 'Night - N',
    childLoads: [],
  },
  {
    id: 234,
    uldNumber: 'UPST720230',
    uldType: 'T',
    loadKey: 'GB',
    uldCount: '0',
    pkgCount: '0',
    loadCreateDate: 'August 8, 2020',
    origSort: 'Night - N',
    childLoads: [],
  },
];
